<template>
  <v-app>
    <navbar/>
    <v-content class="mx-4 mb-4">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import NavBar from './components/NavBar'

export default {
  name: 'App',
  components: {
      'navbar': NavBar
  },
  data () {
    return {
      "results": []
    }
  }
}
</script>
